import UltMeta, { Meta } from "@/meta/UltMeta/index";

class HowToSign extends UltMeta {
    ONLINE = new Meta(1, "线上");
    UNDERLINE = new Meta(2, "线下");
}
export const HOW_TO_SIGN = new HowToSign();

class ContractState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    // TOBESIGN = new Meta(2, "待签署");
    SIGNING = new Meta(3, "签署中");
    DONE = new Meta(4, "已完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}
export const CONTRACT_STATE = new ContractState();
